import { useEffect } from 'react';

/**
 * アクティビティ追跡フック (ローカル専用版)
 * 外部サーバーへの送信は一切行わず、開発環境でのログ出力のみを行います。
 */

const logActivity = (action: string, details?: any) => {
  if (process.env.NODE_ENV === 'development') {
    console.log(`[ActivityLog] ${action}`, details);
  }
};

export const useActivityTracking = (action: string, details?: any) => {
  useEffect(() => {
    logActivity(action, details);
  }, [action, details]);
};

export const trackHabitCreated = (habitName: string) => {
  logActivity('habit_created', { habitName });
};

export const trackHabitCompleted = (habitId: string, date: string) => {
  logActivity('habit_completed', { habitId, date });
};

export const trackPageView = (page: string) => {
  logActivity('page_view', { page });
};
